// Test Data ---
// let BASEURL = 'https://leasing.pro360dev.freemyip.com'
// let FINANCE_URL = 'https://api.apps.rabahrain.com'
// Live Data ---
let BASEURL = 'https://lease.api.apps.rabahrain.com'
let FINANCE_URL = 'https://apinew.apps.rabahrain.com'
export const endPoint = {
    // Lease Aggrement
    CREATE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/CreateLeaseAgreement`,
    UPDATE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/EditLeaseAgreement`,
    GET_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/Get`,
    DELETE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/DeleteLease`,
    // Approval
    GET_LEASE_APPROVAL: `${BASEURL}/api/LeaseApproval/GetApprovalList`,
    // DropDown
    GET_UNITNO_DROP: `${BASEURL}/api/LeaseAgreement/GetDropDown`,
    GET_PROPERT_DROP: `${BASEURL}/api/LeaseAgreement/GetLeaseCreateDdls`,
    GET_UNITNO_DATA: `${BASEURL}/api/LeaseCommon/GetCommonData`,
    RECEIPT_DROPDOWN: `${BASEURL}/api/LeaseReceipt/GetMultipleDropdown`,
    CASCAD_DROP: `${BASEURL}/api/LeaseReceipt/GetCascadDropdown`,
    LEASE_NO_DATA: `${BASEURL}/api/LeaseReceipt/GetCommonData`,
    CREATE_LEASE_RECEIPT: `${BASEURL}/api/LeaseReceipt/CreateReceipt`,
    GET_RECEIPT: `${BASEURL}/api/LeaseReceipt/Get`,
    GET_RECEIPT_BY_NO: `${BASEURL}/api/LeaseReceipt/GetReceiptByNo/`,
    UPDATE_LEASE_RECEIPT: `${BASEURL}/api/LeaseReceipt/UpdateReceipt/`,

    GET_CUSTOMER_LAZY_NAME: `${BASEURL}/api/LeaseCommon/GetCustomersByName`,
    GET_CURRENCY_PER: `${FINANCE_URL}/api/finance/currencies/listing`,

    // Lease General Invoice
    GEN_INV_DROPDOWNS: `${BASEURL}/api/LeaseGeneralInvoice/GetDropdowns`,
    GEN_INV_CASCADE: `${BASEURL}/api/LeaseGeneralInvoice/GetCascadeDropdown`,
    GEN_INV_TAXCODES: `${BASEURL}/api/LeaseGeneralInvoice/GetTaxCodes`,
    GEN_INV_TENANT_BY_UNIT: `${BASEURL}/api/LeaseGeneralInvoice/GetTenantByUnit`,
    GEN_INV_LIST: `${BASEURL}/api/LeaseGeneralInvoice/GetInvoices`,
    GEN_INV_BY_VOUCHER: `${BASEURL}/api/LeaseGeneralInvoice/GetInvoiceByVoucherNo/`,
    GEN_INV_CREATE: `${BASEURL}/api/LeaseGeneralInvoice/CreateInvoice`,
    GEN_INV_UPDATE: `${BASEURL}/api/LeaseGeneralInvoice/UpdateInvoice/`,

    // Lease General Invoice Receipt
    LGIR_DROPDOWNS: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetDropdowns`,
    LGIR_UNIT_PARTY: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetCustomersByUnit`,
    LGIR_CUSTOMER:`${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetCustomerDetail/`,
    LGIR_INVOICES: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetOutstandingInvoices`,
    LGIR_DEBIT_ACCOUNTS: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetDebitAccounts`,
    LGIR_SETOFF_VOUCHERS: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetSetOffVouchers`,
    LGIR_LIST: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetReceipts`,
    LGIR_BY_RDNO: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/GetReceiptByRDNo/`,
    LGIR_CREATE: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/CreateReceipt`,
    LGIR_UPDATE: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/UpdateReceipt/`,
    LGIR_DELETE_SETOFF: `${BASEURL}/api/LeaseGeneralInvoiceReceipt/DeleteSetOffAllocation/`,

    // Lease Reverse Receipt
    LRR_DROPDOWNS: `${BASEURL}/api/LeaseReverseReceipt/GetDropdowns`,
    LRR_UNITS: `${BASEURL}/api/LeaseReverseReceipt/GetUnits`,
    LRR_RECEIPT_LINES: `${BASEURL}/api/LeaseReverseReceipt/GetReceiptLines`,
    LRR_UNALLOCATED: `${BASEURL}/api/LeaseReverseReceipt/GetUnallocatedPayments/`,
    LRR_UPDATE_REMARKS: `${BASEURL}/api/LeaseReverseReceipt/UpdateUnallocatedRemarks`,
    LRR_REVERSE: `${BASEURL}/api/LeaseReverseReceipt/ReverseReceipts`,

    // Miscellaneous Receipt RA
    MRA_DROPDOWNS: `${BASEURL}/api/MiscellaneousReceiptRA/GetDropdowns`,
    MRA_UNITS: `${BASEURL}/api/MiscellaneousReceiptRA/GetUnits`,
    MRA_LEASES: `${BASEURL}/api/MiscellaneousReceiptRA/GetLeases`,
    MRA_DEBIT_ACCOUNTS: `${BASEURL}/api/MiscellaneousReceiptRA/GetDebitAccounts`,
    MRA_TENANT_DETAILS: `${BASEURL}/api/MiscellaneousReceiptRA/GetTenantDetails`,
    MRA_CHECK_DUPLICATE: `${BASEURL}/api/MiscellaneousReceiptRA/CheckDuplicate`,
    MRA_LIST: `${BASEURL}/api/MiscellaneousReceiptRA/GetReceipts`,
    MRA_BY_NO: `${BASEURL}/api/MiscellaneousReceiptRA/GetReceiptByNo/`,
    MRA_CREATE: `${BASEURL}/api/MiscellaneousReceiptRA/CreateReceipt`,

    // Sale Voucher RA
    SVRA_DROPDOWNS: `${BASEURL}/api/SaleVoucherRA/GetDropdowns`,
    SVRA_SETTINGS: `${BASEURL}/api/SaleVoucherRA/GetSettings`,
    SVRA_TAX_CODES: `${BASEURL}/api/SaleVoucherRA/GetTaxCodes`,
    SVRA_CURRENCIES: `${BASEURL}/api/SaleVoucherRA/GetCurrencies`,
    SVRA_COST_CENTRES: `${BASEURL}/api/SaleVoucherRA/GetCostCentres`,
    SVRA_PARTY_CUSTOMERS: `${BASEURL}/api/SaleVoucherRA/GetPartyCustomers`,
    SVRA_CUSTOMER_DETAIL: `${BASEURL}/api/SaleVoucherRA/GetCustomerDetail`,
    SVRA_LIST: `${BASEURL}/api/SaleVoucherRA/GetVouchers`,
    SVRA_BY_NO: `${BASEURL}/api/SaleVoucherRA/GetVoucherByNo/`,
    SVRA_CREATE: `${BASEURL}/api/SaleVoucherRA/CreateVoucher`,
    SVRA_UPDATE: `${BASEURL}/api/SaleVoucherRA/UpdateVoucher/`,



    // Reservation
    GET_MULTI_DROP_RESERV: `${BASEURL}/api/LeaseReservation/GetMultipleDropdown`,
    GET_CASCAD_RESERV: `${BASEURL}/api/LeaseReservation/GetCascadDropdown`,
    GET_RESERV: `${BASEURL}/api/LeaseReservation/Get`,
    GET_RESERV_COMMON: `${BASEURL}/api/LeaseReservation/GetCommonData`,
    GET_RESERV_CREATE: `${BASEURL}/api/LeaseReservation/CreateReservation`,
    GET_RESERV_EDIT: `${BASEURL}/api/LeaseReservation/EditReservation`,
    UPDATE_RENT: `${BASEURL}/api/LeaseReservationApproval/UpdateResrvationRent`,

    // Dashboard
    GET_DASHBOARD_LIST: `${BASEURL}/api/LeaseDashboard/GetDashboardUnits`,
    GET_DASHBOARD_DROP: `${BASEURL}/api/LeaseDashboard/GetMultipleDropdown`,
    GET_DASHBOARD_CASCAD: `${BASEURL}/api/LeaseDashboard/GetCascadDropdown`,
    GET_DASHBOARD_STATS: `${BASEURL}/api/LeaseDashboard/GetDashboardStats`,

    // Lease Reservation Approval
    GET_RESERV_APPROVAL: `${BASEURL}/api/LeaseReservationApproval/GetApprovalList`,
    UPDATE_RESERV_APPROVAL: `${BASEURL}/api/LeaseReservationApproval/UpdateApproval`,
    PUT_HEIGHER_APPROVAL: `${BASEURL}/api/LeaseReservationApproval/SendToHigherApproval`,

    // Lease Property Access
    GET_ACCESS_LIST: `${BASEURL}/api/UserPropertyAccess/GetAccessUsers`,
    GET_ACCESS_LIST_DETAIL: `${BASEURL}/api/UserPropertyAccess/GetAccessByUser`,
    CREATE_PROPERTY_ACCESS: `${BASEURL}/api/UserPropertyAccess/CreatePropertyAccess`,
    // Lease Aggrement Renew
    GET_RENEW_LIST: `${BASEURL}/api/LeaseAgreement/GetRenewList`,
    POST_RENEW_DATA: `${BASEURL}/api/LeaseAgreement/RenewLeaseAgreement`,
    // Lease Termination
    GET_LEASE_TERMINATION: `${BASEURL}/api/LeaseTermination/Get`,
    POST_LEASE_TERMINATION: `${BASEURL}/api/LeaseTermination/CreateLeaseTermination`,
    TERMINATION_COMMON: `${BASEURL}/api/LeaseTermination/GetCommonData`,
    TERMINATION_MULTI: `${BASEURL}/api/LeaseTermination/GetMultipleDropdown`,
    TERMINATION_CASCAD: `${BASEURL}/api/LeaseTermination/GetCascadDropdown`,
    // Lease Termination Status
    TERMINATION_LIST: `${BASEURL}/api/LeaseTermination/TerminationStatusList`,
    TERMINATION_HISTORY_LIST: `${BASEURL}/api/LeaseTermination/TerminationHistoryList`,
    UPDATE_TERMINATION_STATUS: `${BASEURL}/api/LeaseTermination/UpdateTerminationStatus`,
    DELETE_TERMINATION_STATUS: `${BASEURL}/api/LeaseTermination/DeleteTerminationStatus`,
    // Lease Termination Posting
    TERMINATION_POSTING_LIST: `${BASEURL}/api/LeasePosting/GetTerminationPostingFromUserEnd`,
    POST_LEASE_TERMINATION_POSTING: `${BASEURL}/api/LeasePosting/PostLeaseTermination`,
    // Customer Master
    GET_CUSTOMER: `${BASEURL}/api/Customer/Get`,
    POST_CUSTOMER: `${BASEURL}/api/Customer/CreateCustomer`,
    DELETE_CUSTOMER: `${BASEURL}/api/Customer/GetCommonData`,
    EDIT_CUSTOMER: `${BASEURL}/api/Customer/EditCustomer`,
    CUSTOMER_CASCAD: `${BASEURL}/api/Customer/GetCascadDropdown`,
    CUSTOMER_COMMON: `${BASEURL}/api/Customer/GetCommonData`,
    CUSTOMER_MULTI: `${BASEURL}/api/Customer/GetMultipleDropdown`,
    // Lease Reports
    REPORT_MULTI_DROP: `${BASEURL}/api/LeaseReports/GetMultipleDropdown`,
    REPORT_CASCAD: `${BASEURL}/api/LeaseReports/GetCascadDropdown`,
    REPORT_LEASE_UNIT: `${BASEURL}/api/LeaseReports/GetLeaseUnitsAvailability`,
    REPORT_HK_LEASE_UNIT: `${BASEURL}/api/LeaseReports/GetHKLeaseUnitAvailability`,
    REPORT_LEASE_STATEMENT: `${BASEURL}/api/LeaseReports/GetLeaseStatement`,
    REPORT_LEASE_RECEIPT_NO: `${BASEURL}/api/LeaseReports/GetLeaseReceiptLogReceiptNo`,
    REPORT_LEASE_RECEIPT_NARRATION: `${BASEURL}/api/LeaseReports/GetLeaseReceiptLogNarration`,
    REPORT_LEASE_REVENUE: `${BASEURL}/api/LeaseReports/GetLeaseRevenueRental`,
    REPORT_LEASE_MOVE_IN_OUT: `${BASEURL}/api/LeaseReports/GetLeaseMoveInOut`,
    REPORT_MARKETING_MOVE_IN_OUT: `${BASEURL}/api/LeaseReports/GetMarketingMoveInOut`,
    REPORT_AGENT_COMMISSION: `${BASEURL}/api/LeaseReports/GetLeaseAgentCommission`,
    REPORT_COMMISSION_SUMMARY: `${BASEURL}/api/LeaseReports/GetLeaseCommissionSummary`,
    REPORT_COMMISSION_DETAIL: `${BASEURL}/api/LeaseReports/GetLeaseCommissionDetail`,
    REPORT_CUSTOMER_BIRTHDAY: `${BASEURL}/api/LeaseReports/GetCustomerBirthdayList`,
    REPORT_LEASE_EXPIRY:`${BASEURL}/api/LeaseReports/GetLeaseExpiry`,
    REPORT_REFUND_ANALYSIS: `${BASEURL}/api/LeaseReports/GetRefundAnalysis`,
    REPORT_UNIT_LOSS: `${BASEURL}/api/LeaseReports/AvailableUnitRevenueLoss`,
    REPORT_AGEING_ANALYSIS: `${BASEURL}/api/LeaseReports/AgingAnalysisLease`,
    LEASE_INVOICE_PRINT: `${BASEURL}/api/LeaseReports/LeaseInvoicePrint`,
    LEASE_OUTSTANDING_REPORT: `${BASEURL}/api/LeaseReports/GetLeaseOutstanding`,
    UNIT_REVENUE_LOSS_REPORT: `${BASEURL}/api/LeaseReports/AvailableUnitRevenueLoss`,
    REPORT_AGENT_DIRECT: `${BASEURL}/api/LeaseReports/GetAgentDirectReport`,
    REPORT_AGENT_DETAIL: `${BASEURL}/api/LeaseReports/GetAgentDetailReport`,
    REPORT_PM_UNIT_LISTING: `${BASEURL}/api/LeaseReports/GetPMUnitListing`,
    REPORT_UNIT_ANALYSIS_STATUS: `${BASEURL}/api/LeaseReports/GetUnitAnalysisStatusLeasePM`,

    
    // LeaseCommission
    GET_COMMISSION: `${BASEURL}/api/LeaseCommission/Get_All_Agent_Commission`,
    GET_HISTORY_COMMISSION: `${BASEURL}/api/LeaseCommission/Get_All_Agent_Commission_History`,
    POST_COMMISSION: `${BASEURL}/api/LeaseCommission/create`,
    DELETE_COMMISSION: `${BASEURL}/api/LeaseCommission/DeleteCommission`,
    EDIT_COMMISSION: `${BASEURL}/api/LeaseCommission/update`,
    COMMISSION_CASCAD: `${BASEURL}/api/LeaseCommission/cascade-dropdowns`,
    COMMISSION_COMMON: `${BASEURL}/api/LeaseCommission/common-data`,
    COMMISSION_MULTI: `${BASEURL}/api/LeaseCommission/GetMultipleDropdown`,

    // Lease Balance refund
    CASCAD_BLNC_REF: `${BASEURL}/api/LeaseBalanceRefund/cascade-dropdowns`,
    MULTI_BLNC_REF: `${BASEURL}/api/LeaseBalanceRefund/GetMultipleDropdown`,
    COMMON_BLNC_REF: `${BASEURL}/api/LeaseBalanceRefund/common-data`,
    POST_BLNC_REF: `${BASEURL}/api/LeaseBalanceRefund/CreateBalanceRefund`,
    BLNC_REF_LIST: `${BASEURL}/api/LeaseBalanceRefund/GetBalanceRefundList`,
    BLNC_REF_BY_VOUCHER: `${BASEURL}/api/LeaseBalanceRefund/GetBalanceRefundByVoucher/`,
    BLNC_REF_UPDATE: `${BASEURL}/api/LeaseBalanceRefund/UpdateBalanceRefund/`,

    // Property management
    CASCAD_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/GetCascadDropdown`,
    MULTI_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/GetMultipleDropdown`,
    COMMON_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/GetCommonData`,
    POST_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/CreatePropertyTour`,
    UPDATE_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/EditPropertyTour`,
    UPDATE_SCH_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/EditPropertyTourDetails`,
    GET_ONEREPORT_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/GetReportOne`,
    GET_REPORT_TWO_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/GetReportTwo`,
    GET_PROPRTYTOUR: `${BASEURL}/api/LeasePropertyTour/Get`,

    // Unit Master
    GET_UNIT_LIST: `${BASEURL}/api/UnitManagement/GetAll`,
    GET_UNIT_ID: `${BASEURL}/api/UnitManagement/GetById/`,
    GET_UNIT_MULTIDROP: `${BASEURL}/api/UnitManagement/GetMultipleDropdown`,
    GET_UNIT_CASCAD: `${BASEURL}/api/UnitManagement/GetCascadDropdown`,
    CREATE_UNIT: `${BASEURL}/api/UnitManagement/Create`,
    UPDATE_UNIT: `${BASEURL}/api/UnitManagement/Update`,
    DELETE_UNIT: `${BASEURL}/api/UnitManagement/Delete/`,
    GET_UNIT_COMMON: `${BASEURL}/api/UnitManagement/GetCommonData`,

    
    // File Upload
    UNIT_FILE: `${BASEURL}/api/FileUpload/unit-files`,

}
